import axios from 'axios';

interface EnvData {
  apiURL: string;
  token: string;
  createdate: string;
}

const setEnvData = (): EnvData => {
  const data: EnvData = {
    apiURL: '',
    token: '',
    createdate: '',
  };

  switch (window.location.hostname) {
    case 'hub2.jmvtechnology.com': // PROD
      Object.assign(data, {
        apiURL: 'https://static-hub2.jmvstream.com',
        token: '76884bad98fc64408f4394fa472238981b5690ca77e445d4df2400',
        createdate: '20240712',
      });
      break;
    case 'hub2-staging.jmvtechnology.com': // TEST
      Object.assign(data, {
        apiURL: 'https://static-hub2-staging.jmvstream.com',
        token: '76884bad9be57d579c4f99f5027f64c5481f8cc975',
        createdate: '20240712',
      });
      break;
    case 'hub2-sandbox.jmvtechnology.com': // SANDBOX
      Object.assign(data, {
        apiURL: 'https://static-hub2-sandbox.jmvstream.com', // not defined yet
        token: '76884bad9be568589f4498ea027f64c5481f8cc975',
        createdate: '20240712',
      });
      break;
    default: // DEV - LOCAL
      Object.assign(data, {
        apiURL: 'https://static-hub2.jmvstream.com',
        token: '76884bad98fc64408f4394fa472238981b5690ca77e445d4df2400',
        createdate: '20240712',
      });
      break;
  }

  return data;
};

const api = () => {
  const { apiURL, token, createdate } = setEnvData();
  return axios.create({
    baseURL: apiURL,
    headers: {
      token,
      createdate,
    },
  });
};

export default api();
